export const GET_ARTICLES_CATEGORIES = "GET_ARTICLES_CATEGORIES";
export const GET_ARTICLES_CATEGORIES_SUCCESS =
  "GET_ARTICLES_CATEGORIES_SUCCESS";
export const GET_ARTICLES_CATEGORIES_FAIL = "GET_ARTICLES_CATEGORIES_FAIL";
